<template>
  <span class="action-icon left-arrow">
    <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" :opacity="opacity">
        <g id="Desktop-HD-Copy-7" transform="translate(-1200.000000, -35.000000)" :fill="fill">
          <g id="Group-2" transform="translate(1206.800000, 42.700000) rotate(-180.000000) translate(-1206.800000, -42.700000) translate(1184.300000, 19.700000)">
            <polygon id="Shape-Copy-2" transform="translate(22.000000, 23.250000) rotate(-180.000000) translate(-22.000000, -23.250000) " points="29 22.375 18.325 22.375 23.225 17.475 22 16.25 15 23.25 22 30.25 23.225 29.025 18.325 24.125 29 24.125"></polygon>
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<style lang="less"scoped>
  svg {
    vertical-align: middle;
  }
</style>

<script>
  export default {
    props: {
      opacity: {
        type: Number,
        default: 0.5
      },
      fill: {
        type: String,
        default: "#000000"
      }
    }
  }
</script>